import { oc } from '@orpc/contract';
import { inspectionSchema } from '../../estimates/schemas/estimates.schemas.js';
import { updateInspectionInputSchema } from '../schemas/inspections.schemas.js';
/**
 * Upserts the row and bumps the owner's revision in the same transaction, so a concurrent edit of the
 * owner is caught by its own revision predicate (plan §2.3). The owner's status is re-derived after.
 */
export const updateInspectionContract = oc
    .route({
    method: 'PATCH',
    path: '/inspections',
    tags: ['Inspections'],
    summary: 'Record the manual inspection',
})
    .input(updateInspectionInputSchema)
    .output(inspectionSchema);
//# sourceMappingURL=update-inspection.contract.js.map